
<template>
  <div>
    <CRow  class="justify-content-md-center">
      <CCol sm="9">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 案件詳細
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" class="mr-2" color="dark" :href="'/jobs/' + job.id + '/form/'">編集</CButton>
                  <CButton size="sm" color="danger"  @click="deleteModal = true">削除</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="9" class="offset-md-2">
                <dl v-for="(k, v) in labelDic" class="row" :key="k">
                  <dt class="col-sm-3">{{k}}</dt>
                  <dd class="col-sm-9">
                    <div v-if="v == 'state'">
                      <CBadge :color="stateColor(job['state'])">{{ stateDic[job["state"]] }}</Cbadge>
                    </div>
                    <div v-else-if="v == 'created_at'">
                      {{ formatDateTime(job["created_at"]) }}
                    </div>
                    <div v-else-if="v == 'monitor_num'">
                      {{ job["monitor_num"] }} 人
                    </div>
                    <div v-else-if="v == 'images'">
                      <CRow>
                        <CCol v-for="img in imgs" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; ">
                        </CCol>
                      </CRow>
                    </div>
                    <div v-else>
                      {{formatData(k, v)}}
                    </div>
                  </dd>
                </dl>
              </CCol>
            </CCardBody>
          </CCard>

          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 応募情報
              <div class="card-header-actions">
              </div>
            </CCardHeader>
            <CCardBody class="px-0">
              <CCol md="12" class="px-0" >
              </CCol>
            </CCardBody>
          </CCard>

      </CCol>

    </CRow>


    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deletePresentModal"
    >
      <div class="text-center">
        <p>この景品を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deletePresent()">削除</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      recordModal: false,
      presentModal: false,
      deletePresentModal: false,
      stateModal: false,
      job: {},
      isEdit: false,
      fields: [
        { key: 'id', label: "ID"},
        { key: 'name', label: "申込者"},
        { key: 'gender', label: "性別"},
        { key: 'birthday', label: "年齢"},
        { key: 'phone_number', label: "電話番号"},
        { key: 'applicate_state', label: "申込ステータス"},
        { key: 'manage_state', label: "配送ステータス"},
        { key: 'post_state', label: "投稿ステータス"},
        { key: 'sns', label: "SNS ID"},
        { key: 'created_at', label: "作成日"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}
      ],
      labelDic: {
        'id' : "ID",
        'title': "求人タイトル",
        'description': "求人内容",
        'background': "募集の背景",
        'qualification': "応募資格",
        'location': "勤務地",
        'employment_form': "雇用形態",
        'salary': "給与",
        'state': "求人公開設定",
        'working_hours': "勤務時間",
        'after_joining': "入社後の流れ",
        "hope_of_country": "希望の国籍",
        'access': "アクセス",
        'tags': "タグ",
        'images': "求人イメージ画像",
        'industry_id': "業種",
        'created_at': "作成日",
      },
      stateDic: {
        'public': '公開中',
        'private': '非公開',
        'draft': '下書き'
      },
      file: null,
      p_index: 0,
      s_index: 0,
      imgs: []
    }
  },
  methods: {
    stateColor: function(e) {
      if(e == "public") {
        return 'success'
      } else if(e == "private") {
        return 'warning'
      } else {
        return 'dark'
      }
    },
    formatDateTime: function(d) {
      return moment(d).format("YYYY年MM月DD日 HH:mm")
    },
    hideModal: function() {
      this.presentModal = false
      this.deletePresentModal = false
    },
    editState: function(a, i) {
      this.applicate = a
      this.s_index = i
      this.stateModal = true
    },
    formatData: function(label, d) {
        console.log(label)
        console.log(d)
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else if(label == "preview") {
          return
        } else {
          return this.job[d]
        }
    },
    upImage: function(f) {
        this.file = f[0]

        const reader = new FileReader();
        reader.onload = (e) => {
          this.image_data = e.target.result;
        }
        reader.readAsDataURL(this.file);
    },
    showRecordModal: function(i, index) {
      this.recordModal = true

      this.itemIndex = index
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/jobs/" + this.$route.params.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.job = response.data
          this.imgs = this.job.images.split(",")

      }).catch(error => {
          console.log(error)
      })
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

<style scoped>

.w-60 {
  width: 60%;
}
.w-10 {
  width: 10%;
}
.w-100 {
  width: 80%;
}
</style>
